import home from './home'
import common from './common'
import other from './other'
import mall from './mall'
import family from './family'
import health from './health'
import news from './news'
import mine from './mine'
import equipment from './equipment'
import enterprise from './enterprise'
import activity from './activity'
import vip from './vip'
import staticpage from './static'
import coupon from './coupon'
import questionnaire from './questionnaire'

const routes = [
  ...home,
  ...common,
  ...other,
  ...mall,
  ...family,
  ...health,
  ...news,
  ...mine,
  ...equipment,
  ...enterprise,
  ...activity,
  ...vip,
  ...coupon,
  ...questionnaire,
  ...staticpage
]

export default routes
